module.exports = __webpack_public_path__ + "static/media/market-1.16813513.jpg";